<template>
  <div class="footer">
    <div class="footer__logo">
      <img
        src="../../../../images/common/footer_logo.png"
        alt="BSAC JAPAN"
        class="footer__logo-image"
      />
    </div>
    <nav class="footer__nav">
      <div class="footer__nav-inner">
        <ul class="footer__nav-items">
          <li class="footer__nav-item">
            <a href="https://www.bsac.co.jp/terms/" class="footer__nav-item-link" target="_blank">
              ご利用規約/特定商取引法に基づく表記
            </a>
          </li>
          <li class="footer__nav-item">
            <a href="https://www.bsac.co.jp/privacy/" class="footer__nav-item-link" target="_blank">
              プライバシーポリシー
            </a>
          </li>
          <li class="footer__nav-item">
            <a :href="digitalTransformationUrl" class="footer__nav-item-link" target="_blank">
              デジタル・トランスフォーメーション
            </a>
          </li>
        </ul>
        <div class="footer__copyright">&copy;&nbsp;{{ thisYear }}&nbsp;BSAC JAPAN LIMITED</div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * デジタルトランスフォーメーションページへのリンクを取得する
     */
    digitalTransformationUrl: function () {
      return `${window.location.protocol}//${window.location.host}/common/documents/show#/digital-transformation`;
    },
    /**
     * 現在の西暦年を取得する
     */
    thisYear: function () {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: auto;

  background-color: #23398b;
  color: #fff;
  background-image: -webkit-linear-gradient(90deg, #16255a 0%, #23398b 50%);
  background-image: linear-gradient(0deg, #16255a 0%, #23398b 50%);

  /* height: auto; のための設定 */
  overflow: hidden;
  position: relative;
  /* height: auto; のための設定 */

  &__logo {
    width: 100%;
    max-width: 1000px;
    height: auto;
    margin: auto;
    padding: 1.5rem 0 1rem 1rem;
    position: relative;
  }

  &__logo-image {
    width: 300px;
    height: auto;
  }

  &__nav {
    border-top: 1px solid;
    font-size: 10px;
    line-height: 20px;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  &__nav-inner {
    width: 100%;
    max-width: 1000px;
    height: auto;
    margin: auto;
    position: relative;
  }

  &__nav-items {
    padding: 5px 0;
    float: left;
    list-style: none;
  }

  &__nav-item {
    float: left;
    margin-right: 42px;
  }

  &__nav-item-link {
    display: block;
    color: #fff;
    text-decoration: none;
  }

  &__copyright {
    border-left: 1px solid;
    padding: 5px 0 5px 40px;
    float: left;
  }
}
</style>
